// PaymentSuccess.jsx
import React from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import TopNavbar from "../Nav/TopNavbar";
import Footer from "./Footer";
import { Container } from "@material-ui/core";

export default function PaymentSuccess() {
  const { state } = useLocation();
  const order = state?.order;

  return (
   <>
   <TopNavbar returnTo={true}/>
   <br/>
   <br/>
   <br/>
   <Container>
     <SuccessWrapper>
      <h2>🎉 Payment Successful!</h2>
      <p>Thank you, {order?.customer.firstName}! We’ve received your payment for the <strong>{order?.product.name.toUpperCase()}</strong> Edition.</p>
      <p>Order ID: {order?.id}</p>
      <p>Check your email for your software delivery and license.</p>
    </SuccessWrapper>
   </Container>
   <br/>
   <Footer/>
   </>
  );
}

const SuccessWrapper = styled.div`
  padding: 60px 20px;
  max-width: 600px;
  margin: auto;
  text-align: center;
  h2 {
    color: green;
    margin-bottom: 20px;
  }
`;
